<template>
  <div class="content-wrapper">
    <div v-if="!isLoggedIn" ref="overlay" class="overlay">
      <div class="login">
        <div class="tip">登录后可查看内容</div>
        <el-button type="primary" class="login-btn" @click="showLogin">去登录</el-button>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: 'ProtectedContent',
  computed: {
    ...mapGetters(["token"]),
    isLoggedIn() {
      return !!this.token;
    }
  },
  data() {
    return {
      overlayStyle: 'position: absolute!important;top: 0 !important;left: 0 !important;width: 100% !important;height: 100%!important;background: rgba(255, 255, 255, 0.8) !important;backdrop-filter: blur(5px) !important;z-index: 2147483647 !important;pointer-events: all !important;'
    }
  },
  methods: {
    showLogin() {
      this.$root.Bus.$emit("showDialog", 0, true);
    }
  }
}
</script>

<style scoped lang="scss">
.content-wrapper {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(5px);
  z-index: 1000;
  pointer-events: all;
  .login {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    .tip {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
    }
    .login-btn {
      width: 110px;
      height: 40px;
      border-radius: 4px;
      font-size: 14px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// common/protectedContent.vue